import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
};

const confirmParticipateSlice = createSlice({
  name: "confirmParticipate",
  initialState,
  reducers: {
    confirmParticipateStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    confirmParticipateSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    confirmParticipateFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  confirmParticipateStart,
  confirmParticipateSuccess,
  confirmParticipateFailed,
} = confirmParticipateSlice.actions;

export default confirmParticipateSlice.reducer;
